/**
 * Parse a `fetch` Response body as JSON, tolerating non-JSON or empty bodies.
 * Returns `null` when the response isn't JSON or fails to parse — so callers can
 * safely read an error envelope without throwing on a 204 / HTML error page.
 *
 * Shared by the auth UI (login/signup/forgot-password) and AuthContext, which all
 * previously kept a verbatim copy of this helper.
 */
export const parseJsonResponse = async <T>(res: Response): Promise<T | null> => {
  const contentType = res.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) return null;
  try {
    return (await res.json()) as T;
  } catch {
    return null;
  }
};
